// src/components/NoiseBudgetBar.tsx
interface NoiseBudgetBarProps {
  spentSeconds: number
  budgetSeconds: number
}

export function NoiseBudgetBar({ spentSeconds, budgetSeconds }: NoiseBudgetBarProps) {
  const pct = Math.min(100, (spentSeconds / Math.max(1, budgetSeconds)) * 100)
  const overBudget = spentSeconds >= budgetSeconds

  const spentMins  = Math.floor(spentSeconds / 60)
  const budgetMins = Math.floor(budgetSeconds / 60)

  const barColor = overBudget ? 'var(--noise)' : pct > 70 ? 'var(--amber)' : 'var(--accent)'

  return (
    <div className="card" style={{ marginBottom: 'var(--xl)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--sm)' }}>
        <span className="label text-muted">Noise Budget</span>
        <span className="label" style={{ color: barColor }}>
          {spentMins}m / {budgetMins}m
          {overBudget && ' ⚠'}
        </span>
      </div>
      <div className="progress-bar-track">
        <div
          className="progress-bar-fill"
          style={{ width: `${pct}%`, background: barColor }}
        />
      </div>
    </div>
  )
}
